// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 20 20", width: "20", height: "20" }, props),
        React.createElement("path", { fill: "#00297A", fillRule: "evenodd", d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM10 15C12.7614 15 15 12.7614 15 10C15 7.23858 12.7614 5 10 5C7.23858 5 5 7.23858 5 10C5 12.7614 7.23858 15 10 15Z", clipRule: "evenodd" })));
};
Icon.displayName = 'OktaLogo20x20';
export default Icon;
//# sourceMappingURL=OktaLogo20x20.js.map